import { DASHBOARD_NAMES } from 'types';
import { SERVICE_EXPRESS_FILTER_GROUP } from 'utility/constants';

// ISA-2402 (orchestrator triage, session-timeout path, 2026-09-24): single-sourced so every
// session-end path removes the same four filter-storage keys the chassis rehydrates from on
// mount. Originally only signout() cleared these; the 401 session-timeout branch in
// handleError() (redux/actions/member/index.js) left them behind because it never called
// signout(), which left a signed-out user's filtered view (including any Team selection) on
// screen for the next person on a shared service-drive terminal. Do not duplicate these
// `removeItem` calls at a new call site -- import and call this instead, so a future key can
// only be added or removed in one place.
export const clearFilterStorage = () => {
  localStorage.removeItem(`filterOptions-${DASHBOARD_NAMES.ADVISOR_DASHBOARD}`);
  localStorage.removeItem(`filterOptions-${DASHBOARD_NAMES.PARTS_DASHBOARD}`);
  localStorage.removeItem(`filterOptions-${DASHBOARD_NAMES.TECHNICIAN_DASHBOARD}`);
  localStorage.removeItem(`filterOptions-${SERVICE_EXPRESS_FILTER_GROUP}`);
};
